"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogFunction = exports.isValidEventName = void 0;
const constants_1 = require("../lib/constants");
const ValidEventNames = [constants_1.SUGGESTION_CLICKED];
const isValidEventName = (eventName) => ValidEventNames.includes(eventName);
exports.isValidEventName = isValidEventName;
const EventMetadataKeys = [
    'customer_id',
    'distinct_id',
    'search_token',
    'user_token',
    'user_type'
];
// apparently, you can only do so much validation of functions at runtime
// https://stackoverflow.com/questions/50371351/typescript-check-if-objects-property-is-a-function-with-given-signature
const isLogFunction = (func) => {
    // all we can do is verify it is a function that takes two args
    return typeof func === 'function' && func.length === 2;
};
exports.isLogFunction = isLogFunction;
//# sourceMappingURL=Tracking.js.map